/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxStudent from "../../util/remote/ajaxStudent";
import ajaxStudentGroup from "../../util/remote/ajaxStudentGroup";
import Select from "react-select";


const EditClass=(props)=>{

    const [loading, setLoading] = useState(false)
    const [groupList, setGroupList] = useState(false);
    const [group, setGroup] = useState(props.groupID);

    useEffect(() => {
            getGroups();
        }, [props.schoolID]);

    const getGroups = async () => {
        const server_response = await ajaxStudentGroup.fetchGroupList(props.schoolID);
        if (server_response.status === "OK") {
          setGroupList(server_response.details);
        } else {
          setGroupList("404");
        }
    };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(group>0){
            setLoading(true)
            const server_response = await ajaxStudent.updateStudentGroup(props.studentID, group);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g();
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please select the class of the student!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Update Student Group"
            id="model-update-student-group"
            size="md"
            footer={RenderFooter}
        >

            <div className="mb-4 form-group border-1">
                <label htmlFor="">Student Group</label>
                <Select
                    onChange={(e) => setGroup(e.group_id)}
                    getOptionLabel={(option) => option.group_name}
                    getOptionValue={(option) => option.group_id}
                    isSearchable
                    options={Array.isArray(groupList) ? groupList : []}
                    value={
                        Array.isArray(groupList) &&
                        groupList.find((value) => value.group_id === group)
                    }
                />
            </div>
           
       
        </SystemModal>
    )
}

export default EditClass
